export const SELECTOR_SYNTAX_DD_ACTION = 'explore-selector-syntax-submission';
